import { useEffect, useState } from 'preact/hooks';
import { PudoLocation } from '@pperform/pp-data-mappers';
import { getShipmentCollectionPoint } from '../../../services';

export const useDropOffLocationContainer = (
  organizationId: number,
  shipmentPk: number,
): { data: PudoLocation; isLoading: boolean } => {
  const [data, setData] = useState<PudoLocation | null>();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    getShipmentCollectionPoint(organizationId, shipmentPk).then((res) => {
      setData(res);
      setIsLoading(false);
    });
  }, []);

  return { data, isLoading };
};
